import { WrapperReducersDefinited } from './interfaces';

export const wrapperReducers: WrapperReducersDefinited = [];
